export default __webpack_public_path__ + "static/media/restoreIcon.b0836f87.svg";